import { getLang, isEN, isZH } from "../../../_util/locale";

import enUS from "./en-US";
import zhCN from "./zh-CN";

const languages = { "en-US": enUS, "zh-CN": zhCN };

export default (key: string) => {
  const language = getLang();
  return languages[language][key];
};

export { isEN, isZH };
